<template>
  <div class="mc-livetrack--qa-sidebar-history">
    <div
      v-for="(item, index) in dataHistory"
      :key="index"
      class="mc-livetrack--qa-sidebar-history-item clearfix"
    >
      <div class="mc-livetrack--qa-sidebar-history-item-line">
        <i class="mc-fa icon-outline_arrow-circle-right"></i>
      </div>
      <div class="mc-livetrack--qa-sidebar-history-item-detail">
        <b-skeleton-wrapper :loading="isLoading">
          <template #loading>
            <b-skeleton width="90%" />
            <b-skeleton width="70%" />
            <b-skeleton width="70%" />
            <b-skeleton width="60%" />
            <b-skeleton width="50%" />
            <b-skeleton width="60%" />
          </template>
          <p style="grid-area: history-date;">
            {{ formatIndexDate(item.created_on).date }}
          </p>
          <span class="text-muted" style="grid-area: history-time;">{{ formatIndexDate(item.created_on).time }}</span>
          <div style="grid-area: history-detail;">
            <p>{{ item.title }}</p>
            <div class="text-muted">
              <span>{{ item.description }}</span>
              <span
                v-for="property in item.properties"
                :key="`${property.key}-${property.value}`"
              >
                <span v-if="property.key.toLowerCase().includes('tanggal')">
                  {{ property.key }}: {{ formatIndexDate(property.value).date }}
                  {{ formatIndexDate(property.value).time }}
                </span>
                <span v-else-if="property.value"> {{ property.key }}: {{ property.value }} </span>
              </span>
            </div>
          </div>
        </b-skeleton-wrapper>
      </div>
    </div>
    <div class="mc-livetrack--qa-sidebar-history-item clearfix">
      <div class="mc-livetrack--qa-sidebar-history-item-line">
        <i class="mc-fa icon-fill_radio-button-on"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { formatIndexDate } from '@/helpers/tzDate'

export default {
  props: {
    dataHistory: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isLoading() {
      return this.loading
    },
  },

  methods: {
    formatIndexDate,
  },
}
</script>